<template lang="">
    <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <CustomerServiceNavigation/>
                <div class="cs_tabPanel active" id="cs_tab05">
                    <h5 class="title">개인정보처리방침</h5>
                    <div class="policy_wrap">
                        <div class="tit">
                            개인정보취급방침
                        </div>
                        <p class="txt">
                            '디지털로고스'는 (이하 "회사" 라 한다) 이용자의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. <br>
                            회사는 개인정보취급방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 <br>
                            취해지고 있는지 알려드립니다. 만일 개인정보취급방침을 개정하는 경우에는 웹사이트 공지사항(또는 개별공지)을 통하여 안내해 드립니다.
                        </p>
                        <div class="sub_tit">
                            1. 수집하는 개인정보의 항목 및 수집방법
                        </div>
                        <p class="txt">
                            회사는 원활한 고객상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. 단, 이용자의 기본적 인권 침해의 우려가 있는 민감한 <br>
                            개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.
                        </p>
                        <div class="sub_tit">
                            1) 수집하는 개인정보의 항목
                        </div>
                        <p class="txt">
                            - 필수항목 : 이름,휴대전화번호,전자우편주소,희망ID(회원의 경우),비밀번호(회원의 경우) <br>
                            - 선택항목 : 생년월일,전화번호,주소,뉴스레터/SMS 수신여부 <br>
                            - 자동수집항목 : IP Adreess, 방문일시, 쿠키정보
                        </p>
                        <div class="sub_tit">
                            2) 개인정보의 수집방법
                        </div>
                        <p class="txt">
                            인터넷 회원가입, 전화, 상담 게시판, 이벤트 응모, 제휴사로 부터의 제공, 배송요청
                        </p>
                        <div class="sub_tit">
                            3) 수집 및 이용 목적
                        </div>
                        <p class="txt">
                            - 회원 관리(본인확인, 개인식별, 부정이용 방지와 비인가사용 방지, 가입의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달) <br>
                            - 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 컨텐츠 제공, 서비스 및 가입상담 <br>
                            - 마케팅/광고 활용 (이벤트 등 광고성 정보전달 , 인구통계학적 특성에 따른 서비스 제공 및 광고 게재
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';

export default {
    components: {
        CustomerServiceNavigation
    }

}
</script>
<style lang="">

</style>